import React, { Component } from "react";

const Loader = ({title}) => {
  return (
    <div className="px-loader-wrapper">
      <div className="px-cssload-loader"></div>
      {title && <h4>{title}</h4>}
    </div>
  );
};

export default Loader;
